const buildFormItem = (label: string, value: string | number) => {
    return { label: label, value: value.toString() };
};

export default buildFormItem;
